import { FormControl, TextareaAutosize } from "@mui/material";
import useDebounce from "helpers/useDebounce";
import { useCallback, useEffect, useState } from "react";
import { TextareaStyle } from "theme";

const FormCardNotes = ({
  groupId,
  notes,
  setNotes,
}: {
  groupId?: number;
  notes?: string | null;
  setNotes: (groupId?: number, notes?: string) => void;
}) => {
  const delay = 500;
  const [internalValue, setInternalValue] = useState(notes || undefined);
  const debouncedValue = useDebounce(internalValue, delay);
  const onChange = (newNote?: string) => {
    setNotes(groupId, newNote);
  };
  const onInputChange = useCallback(
    (event) => {
      setInternalValue(event.target.value);
    },
    [setInternalValue]
  );

  useEffect(() => {
    if (notes !== internalValue) {
      setInternalValue(notes || "");
    }
  }, [notes]);

  useEffect(() => {
    if (debouncedValue !== notes) {
      onChange(debouncedValue);
    }
  }, [debouncedValue]);

  return (
    <FormControl fullWidth>
      <TextareaAutosize
        maxRows={4}
        minRows={3}
        value={internalValue}
        style={{
          ...TextareaStyle,
          height: "13px",
        }}
        onChange={onInputChange}
      />
    </FormControl>
  );
};

export default FormCardNotes;
